import { createTheme } from '@mui/material/styles';
import { responsiveFontSizes } from "@mui/material/styles";

export const getTheme = (mode) => {
  return responsiveFontSizes(
    createTheme({
      palette: {
        mode,
        primary: {
          main: '#356fc1',
          light: '#356fc1',
          dark: '#356fc1',
          contrastText: '#ffffff',
        },
        
        background: {
          default: mode === 'light' ? '#ededed' : '#0e151f',
          paper: mode === 'light' ? '#ffffff' : '#181f2c',
        },
      },
      typography: {
        fontSize: 13,
        subtitle1: {
          fontWeight: 'bold',
        },
      },
      components: {
        MuiDialog: {
          styleOverrides: {
            paper: {
              backgroundColor: '#181f2c',
              color: '#fff',
              backgroundImage: 'none',
            },
          },
        },
      },
    })
  )
}
